module.exports = __webpack_public_path__ + "img/echo.f6c44bc8.jpg";